import React, { PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';

export interface AppDrawerState {
    width: number;
    setWidth: (width: number) => void;
}

export const AppDrawerContext = React.createContext<AppDrawerState | undefined>(undefined);

export function useAppDrawer(): AppDrawerState {
    const context = useContext(AppDrawerContext);

    if (!context) {
        throw new Error('useAppDrawer must be nested inside a AppDrawerProvider');
    }

    return context;
}

export function AppDrawerProvider(props: PropsWithChildren<unknown>): React.JSX.Element {
    const [width, setWidth] = useState(0);
    const setNewWidth = useCallback(newWidth => setWidth(newWidth), []);
    const context = useMemo<AppDrawerState>(() => ({ width, setWidth: setNewWidth }), [width, setNewWidth]);

    return <AppDrawerContext.Provider value={context}>{props.children}</AppDrawerContext.Provider>;
}
